import type {MessagesType} from 'src/lib/translates/types'
import {APIService, type InstanceApi} from 'services/api/api';
import {APIServiceTranslates, GetMessagesParamsType} from './entities';

class RestAPIServiceTranslates implements APIServiceTranslates {

  api: InstanceApi | null = null;

  public init(messages?: MessagesType) {
    const api = new APIService({messages})
    this.api = api.getInstanse();
  }

  private getTranslatesUrl() {
    return `/translates`;
  }

  public getTranslates = async (params: GetMessagesParamsType): Promise<MessagesType> => {        
    if (this.api) {
      try {
        const response = await this.api.get<MessagesType>(
          this.getTranslatesUrl(),
          {params},
        );

        return response.data;
      }catch(error){
        throw Error('RestAPIServiceTranslates.getTranslates: ' + JSON.stringify(error));
      }
    }
    throw Error('RestAPIServiceTranslates: axios is broken');
  }
}

export const restAPIServiceTranslates = new RestAPIServiceTranslates();
